<template>
  <div :style="{ '--img-cp': primary, '--img-cs': secondary }">
    <slot v-if="$slots.default" />
    <InlineSvg v-else :src="src" class="w-auto h-auto max-h-full max-w-full" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import InlineSvg from 'vue-inline-svg'

import { useSystemStore } from '@/stores'

const system = useSystemStore()

const props = defineProps<{
  primary?: string
  secondary?: string
  primaryDark?: string
  secondaryDark?: string
  primaryUseDark?: boolean
  secondaryUseDark?: boolean
  useSecondary?: boolean
  src?: string
}>()

const sysColors = computed(() => system.getConfig.colors.images)

const primary = computed(() =>
  (system.isDark && (props.primaryUseDark === true || sysColors.value.primary.useDark))
    ? (props.primaryDark || sysColors.value.primary.dark)
    : (props.primary || sysColors.value.primary.light)
)
const secondary = computed(() =>
  (props.useSecondary === true || sysColors.value.secondary.useCustom)
    ? (system.isDark && (props.secondaryUseDark === true || sysColors.value.secondary.useDark))
      ? (props.secondaryDark || sysColors.value.secondary.dark)
      : (props.secondary || sysColors.value.secondary.light)
    : sysColors.value.secondary.default
)
</script>

<style>
.cp {
  fill: var(--img-cp) !important;
  transition: all 0.1s ease-in-out;
}
.cp-stroke {
  stroke: var(--img-cp) !important;
}
.cs {
  fill: var(--img-cs) !important;
  transition: all 0.1s ease-in-out;
}
.cs-troke {
  stroke: var(--img-cs) !important;
}
</style>
